import requestApi, { HTTP_METHOD } from '@/utils/axios.http';
import { TEmailReminderSchema } from '@/schemas/email-reminder/email-reminder.schema';
import { ListAllEmailReminder } from '../entities/email-reminder';

const EMAIL_REMINDER_URI = '/emailReminder';

export const createEmailReminder = async (
  emailReminder: TEmailReminderSchema,
) => {
  return requestApi({
    url: EMAIL_REMINDER_URI,
    method: HTTP_METHOD.POST,
    body: emailReminder,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const listAllEmailReminders = async (query?: ListAllEmailReminder) => {
  let url = `${EMAIL_REMINDER_URI}/listAll`;
  const params = new URLSearchParams();

  if (query?.globalEmailSettingId) {
    params.append('globalEmailSettingId', query.globalEmailSettingId);
  }

  if (query?.groupId) {
    params.append('groupId', query.groupId);
  }

  if (params.toString()) {
    url += `?${params.toString()}`;
  }

  return requestApi({
    url,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const updateEmailReminder = async (
  emailReminder: TEmailReminderSchema,
) => {
  return requestApi({
    url: EMAIL_REMINDER_URI,
    method: HTTP_METHOD.PATCH,
    body: emailReminder,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const deleteEmailReminder = async (id: string) => {
  return requestApi({
    url: `${EMAIL_REMINDER_URI}/delete/${id}`,
    method: HTTP_METHOD.DELETE,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};
